import { StandardDispatchFunction } from '../actionTypes';

export function stripeControlConfiguredAction() {
  return (dispatch: StandardDispatchFunction): Promise<void> => {
    return dispatch({ type: 'STRIPE_CONTROL_IS_CONFIGURED' });
  };
}
